import { defineStore } from 'pinia';

export const useRegistrationStore = defineStore('registration', {
  state: () => ({
    // Store query parameters that need to be preserved across registration flow
    preservedQueryParams: {},
    // Track registration form data
    registrationData: {},
    // Track which step user is on
    currentStep: 'register' // 'register' | 'confirm' | 'success'
  }),

  actions: {
    // Set preserved query parameters (like partner=)
    setPreservedQueryParams(queryParams) {
      this.preservedQueryParams = { ...queryParams };
    },

    // Get preserved query parameters
    getPreservedQueryParams() {
      return this.preservedQueryParams;
    },

    // Set registration form data
    setRegistrationData(data) {
      this.registrationData = { ...data };
    },

    // Clear registration data when complete
    clearRegistrationData() {
      this.registrationData = {};
      this.preservedQueryParams = {};
    },

    // Set current step
    setCurrentStep(step) {
      this.currentStep = step;
    },

    // Clear all registration state
    reset() {
      this.preservedQueryParams = {};
      this.registrationData = {};
      this.currentStep = 'register';
    }
  },

  getters: {
    // Get specific preserved query param
    getPreservedParam: (state) => (paramName) => {
      return state.preservedQueryParams[paramName];
    },

    // Check if we have preserved params
    hasPreservedParams: (state) => {
      return Object.keys(state.preservedQueryParams).length > 0;
    }
  }
});
